import { useQueryURL } from '../../../hooks/useQueryURL'
import { DocumentType } from './types'

export const DOC_DETAILS_TYPE = 'doc_details_type'

export function useDocumentDetailsType(): DocumentType | null {
  const query = useQueryURL()
  return query.get(DOC_DETAILS_TYPE) as DocumentType
}
